import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Button, Text } from '@components/common';
import SvgIcon from '@components/SvgIcon';

const ButtonWrapper = styled(Button)`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: 0;
`;

const ContentWrapper = styled(Box)`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const Subtitle = styled(Text)`
  font-size: 12px;
`;

function AddonSingleSelector(props) {
  const {
    icon,
    title,
    size,
    subtitle,
    selected,
    disabled,
    ...restProps
  } = props;
  const titleColor = selected ? 'white' : 'grey.0';
  const subtitleColor = selected ? 'white' : 'lightText';
  const variant = selected ? 'primary' : 'secondary';

  const iconProps = {
    width: size || 16,
    height: size || 16,
    color: selected ? 'white' : 'gold',
    fill: selected ? 'white' : 'gold'
  };

  return (
    <ButtonWrapper disabled={disabled} variant={variant} {...restProps}>
      <SvgIcon name={icon} {...iconProps} />
      <ContentWrapper ml={2}>
        {title && (
          <Text color={!disabled ? titleColor : 'grey.1'}>{title}</Text>
        )}
        {subtitle && (
          <Subtitle color={!disabled ? subtitleColor : 'grey.1'}>
            {subtitle}
          </Subtitle>
        )}
      </ContentWrapper>
    </ButtonWrapper>
  );
}

AddonSingleSelector.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  selected: PropTypes.bool,
  size: PropTypes.string,
  disabled: PropTypes.bool
};

export default AddonSingleSelector;
